/*
 * @Author: zhihua
 * @Date: 2020-01-15 15:54:16
 * @LastEditTime : 2020-01-17 20:22:00
 * @LastEditors  : Please set LastEditors
 * @Description: 交易明细store
 * @FilePath: /fx-operate-admin/src/stores/finance/transactionDetail.js
 */
import { observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
const { finance } = api;

class TransactionDetail {
    constructor() {
        this.updataStore = this.updataStore.bind(this);
        this.queryTradeAmount = this.queryTradeAmount.bind(this);
    }
    // 交易明细 数据源
    @observable pageInfo = {
        pageSize: 10,
        pageIndex: 1,
    };
    @observable total = 0;
    @observable formData = {
        bizType: null,
        payTimeEnd: null,
        payTimeStart: null,
        keyType: null,
        keyNo: null
    };
    @observable isLoading = false;

    // Byte SUPPLIER = Byte.valueOf("1");//供应商
    // Byte MEMBERS = Byte.valueOf("2");//会员
    // Byte PLATFORM = Byte.valueOf("3");//平台
    @observable userType = 1;
    @observable tradeList = [];
    @observable tradeAmount = {};

    @action async updataStore(key, value) {
      let type = typeof key;
      let _self = this;
      switch(type) {
        case 'object':
          Object.keys(key).forEach(item => { _self[item] = key[item];});
          break;
        default:
          _self[key] = value;
      }
    }

    //查询交易明细（支持供应商或会员，根据用户类型区分
    @action async queryTrade(params) {
        const realParams = {
            userType: this.userType,
            ...this.pageInfo,
            ...params
        }
        this.isLoading = true;
        const {
            data: {
                page = 1,
                pageSize = 10,
                total = 0,
                list = [],
            }
         } = await httpClient.post(finance.QUERTY_TRADE, { ...realParams });
        this.isLoading = false;
        this.tradeList = list;
        this.pageInfo = { pageSize, pageIndex: page };
        this.total = total;
    }

    // 查询总收支金额
    @action async queryTradeAmount(params) {
      const { data = {} } = await httpClient.post(finance.QUERY_TRADE_AMOUNT, {
        userType: this.userType,
        ...this.formData,
        ...params
      });
      this.tradeAmount = data;
    }
    @action switchover(userType) {
      this.pageInfo = {
        pageSize: 10,
        pageIndex: 1,
      }
      this.formData = {
        bizType: null,
        payTimeEnd: null,
        payTimeStart: null,
        keyType: null,
        keyNo: null
      };
      this.userType = userType;
      this.total = 0;
      this.tradeAmount = {};
    }


}

export default new TransactionDetail()